import React, { useEffect, useState } from "react";
import axios from "axios";
import ButtonPrimary from "./Button-primary";

const UnitPriceCalculator = () => {
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [showClearButton, setShowClearButton] = useState(false);
  const [transactionHash, setTransactionHash] = useState("");

  const getHash = (event) => {
    if (event.target.name === "transactionHash") {
      const hash = event.target.value.split("/").pop();
      setTransactionHash(hash);
    }
  };

  const calculateUnitPrice = () => {
    if (price === "" || quantity === "") {
      return "Please enter a price and quantity";
    }
    const unitPrice = price / quantity;
    return `Unit Price : $${unitPrice.toFixed(4)}`;
  };

  const handleInputChange = (event) => {
    if (event.target.name === "price") {
      setPrice(event.target.value);
    } else {
      setQuantity(event.target.value);
    }
    setShowClearButton(event.target.value !== "");
  };

  const clearInputs = () => {
    setPrice("");
    setQuantity("");
    setShowClearButton(false);
  };

  const [txInfos, seTxInfos] = useState({});


  useEffect(() => {
    const fetchTxInfos = async () => {
      const response = await axios.get(
        `https://cryptools-server-production.up.railway.app/transactions?transactionHash=${transactionHash}`
        // `http://localhost:4000/transactions?transactionHash=${transactionHash}`,
      );
      seTxInfos(response.data);
    };
    fetchTxInfos();
  }, [transactionHash]);

  return (
    <div>
      <div className="flex flex-col w-10/12 p-4 m-auto mt-5 space-y-4 border border-gray-200 rounded-lg bg-blue-50 sm:w-1/3">
        <h1 className="m-auto text-xl font-bold">Unit Price Calculator</h1>
        <div className="flex flex-row justify-around">
          <button
            onClick={() => {
              document
                .getElementById("unitPriceTxHash")
                .classList.remove("hidden");
              document
                .getElementById("unitPriceQuantity")
                .classList.add("hidden")
                .classList.remove("flex");
            }}
            className="w-10/12 p-2 m-auto text-lg font-medium text-white transition bg-blue-400 rounded-lg hover:bg-blue-600"
          >
            By Tx Hash
          </button>
          <ButtonPrimary text={"By Tx Hash"} func={() => {
              document
                .getElementById("unitPriceTxHash")
                .classList.remove("hidden");
              document
                .getElementById("unitPriceQuantity")
                .classList.add("hidden")
                .classList.remove("flex");
            }}/>
          <button
            onClick={() => {
              document
                .getElementById("unitPriceTxHash")
                .classList.add("hidden")
                .classList.remove("flex");
              document
                .getElementById("unitPriceQuantity")
                .classList.remove("hidden")
                .classList.add("flex");
            }}
            className="w-4/12 p-2 m-auto text-lg font-medium text-white transition bg-blue-400 rounded-lg hover:bg-blue-600 active:bg-blue-600"
          >
            By Quantity
          </button>
        </div>
      </div>

      <div className="relative">
        <div
          id="unitPriceTxHash"
          className="flex flex-col w-10/12 p-4 m-auto mt-5 space-y-4 border border-gray-200 rounded-lg bg-gray-50 sm:w-1/3"
        >
          <label>Transaction hash</label>
          <input
            type="link"
            name="transactionHash"
            onChange={getHash}
            className="p-2 mt-1 rounded-lg"
          />
          <br />
          <p className="m-auto text-xl font-bold">{calculateUnitPrice()}</p>
        </div>
        <div className="absolute inset-0 flex items-center justify-center bg-opacity-50 bg-gray-50 backdrop-filter backdrop-blur-lg">
          <p className="text-3xl font-bold text-gray-700">Coming Soon</p>
        </div>
        </div>
      <div
        id="unitPriceQuantity"
        className="flex-col hidden w-10/12 p-4 m-auto mt-5 space-y-4 border border-gray-200 rounded-lg bg-gray-50 sm:w-1/3"
      >
        <label>Price: </label>
        <input
          type="number"
          name="price"
          value={price}
          onChange={handleInputChange}
          className="p-2 mt-1 rounded-lg"
        />
        <br />
        <label>Quantity: </label>
        <input
          type="number"
          value={quantity}
          onChange={handleInputChange}
          className="p-2 mt-1 rounded-lg"
        />
        <br />
        {showClearButton && (
          <button
            onClick={clearInputs}
            className="w-4/12 m-auto text-lg font-medium text-white transition bg-red-400 rounded-lg hover:bg-red-600"
          >
            Clear
          </button>
        )}
        <button
          onChange={handleInputChange}
          className="w-8/12 p-2 m-auto text-lg font-medium text-white transition bg-blue-400 rounded-lg hover:bg-blue-600"
        >
          Calculate Unit Price
        </button>
        <br />
        <p className="m-auto text-xl font-bold">{calculateUnitPrice()}</p>
      </div>
    </div>
  );
};

export default UnitPriceCalculator;
